import { Component, OnInit } from '@angular/core';
import { ApplicationStorage } from './../services/applicationStorage';


@Component({
  selector: 'app-outro',
  templateUrl: './outro.component.html',
  styleUrls: ['./outro.component.css']
})
export class OutroComponent implements OnInit {
  surveyOutroText: any;
  surveyType: any;


  constructor(private applicationStorage: ApplicationStorage) { }

  ngOnInit(): void {
    this.surveyOutroText = localStorage.getItem("surveyOutroText");
    this.surveyType = localStorage.getItem("surveyType");
    this.surveyOutroText = this.surveyOutroText?.replace(/([.!?])\s*(?=[A-Z0-9])/g, "$1<br>");

    // this.surveyOutroText = this.surveyOutroText.replace("\n", "<br>");
    // console.log("surveyOutroText:", this.surveyOutroText);
    console.log("scroll");
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
